import { useMutation } from "@tanstack/react-query";
import { QueryKeys, client, queryClient } from "queryClient";
import { CreateCalcTaskInput } from "types";

/**
 * Kein optimistisches Einfügen mehr: die Liste ist seitenweise geladen
 * (InfiniteData mit pages/pageParams), ein Array-Patch würde den Cache
 * zerstören. Die Invalidierung nach Abschluss lädt die Seiten neu; die
 * Sperrlogik der Oberfläche hängt ohnehin an useCalcTaskRunningList mit
 * eigenem Schlüssel und Subscription.
 */
export const useCalcTaskCreate = () => {
  const createMutation = useMutation({
    mutationFn: async (input: CreateCalcTaskInput) => {
      const { data: newCalcTask } = await client.models.CalcTask.create(input);
      return newCalcTask;
    },
    onMutate: async () => {
      // Laufende Neuladungen abbrechen, damit sie das Ergebnis nicht überholen.
      await queryClient.cancelQueries({ queryKey: [QueryKeys.CalcTasks] });
    },
    onError: (err, newCalcTask) => {
      console.error("Error saving record:", err, newCalcTask);
    },
    // Always refetch after error or success:
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: [QueryKeys.CalcTasks] });
    },
  });

  return createMutation;
};
